/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import styles from './ElectroFileTransfer.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

export type TypeProps = {
  // eslint-disable-line flow-prefer-exact-object-types
  variant: string,
  field: Object,
} & TranslatorProps;

@translate()
@observer
export default class ElectroFileTransfer extends React.Component<*> {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
    this.fileInput = React.createRef();
  }

  handleMouseEnter = () => {
    this.setState({
      isHovered: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      isHovered: false,
    });
  };

  handleFileUpload = (selectorFiles: FileList, vField: Object) => {
    selectorFiles
      ? (vField.value = selectorFiles[0]) //.name
      : this.handleFileRemoval(vField);
  };

  handleFileRemoval = (vField: Object) => {
    vField.value = '';
    this.fileInput.current.value = '';
  };

  renderFileUpload(vField: Object): React.Element<*> {
    const { t }: TypeProps = this.props;

    return (
      <React.Fragment>
        <svg>
          <use xlinkHref={vField.value ? '#icon-orders' : '#icon-upload'} />
        </svg>
        <input
          className={styles['input-upload']}
          id="upload"
          type="file"
          ref={this.fileInput}
          onChange={(e: *) => this.handleFileUpload(e.target.files, vField)}
        />
        <label htmlFor="upload">
          {vField.value ? vField.value.name : t('general:messages.drag_and_drop')}
        </label>
        {vField.value && (
          <Button variant="flat" onClick={() => this.handleFileRemoval(vField)}>
            Remove File
          </Button>
        )}
      </React.Fragment>
    );
  }

  render(): React.Element<*> {
    const { field }: TypeProps = this.props;

    const isRequired: boolean = Boolean(field.rules && field.rules.includes('required'));
    const isError: boolean = Boolean(field.error && field.showError);
    const isHoveredClass: string = this.state.isHovered ? styles['is-hovered'] : '';

    return (
      <div className={`${styles['electro-file-transfer']}`}>
        <FormControl error={isError}>
          <InputLabel required={isRequired} shrink={true}>
            {field.label}
          </InputLabel>

          <div
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            className={`${styles['drag-drop']} ${isHoveredClass}`}
          >
            {this.props.variant === 'upload'
              ? this.renderFileUpload(field)
              : this.renderFileDownload()}
          </div>

          {isError && <FormHelperText error={true}>{field.error}</FormHelperText>}
        </FormControl>
      </div>
    );
  }
}
